import React from 'react'
import PropTypes from 'prop-types'
import Slider from 'react-slick'
import DhsvBlogItem from './blogItem'
import reducer from './state'

class DhsvPostHighlightSlider extends React.Component {
  constructor(props) {
    super(props)
    this.state = reducer()
    this.dispatch = this.dispatch.bind(this)
  }

  dispatch(action) {
    if (typeof action === 'function') {
      action(this.dispatch, () => this.state)
    } else {
      this.setState(prevState => reducer(prevState, action))
    }
  }

  render() {
    // eslint-disable-next-line no-unused-vars
    const { itemStyle, firstPageLoaded } = this.state
    // eslint-disable-next-line no-unused-vars
    const { readMore, data, handleCategoryChange, headline } = this.props

    const settings = {
      infinite: true,
      speed: 500,
      slidesToShow: 3,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 950,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 680,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    }
    console.log(data)
    return this.props.data.length > 0 ? (
      <div className="highlight-slider">
        <span className="spotlight-badge">
          <p>Spotlight</p>
        </span>
        <div className="slider-headline">{headline}</div>
        <Slider {...settings}>
          {this.props.data.map((item, index) => (
            <DhsvBlogItem
              key={index}
              index={index}
              item={item.data}
              itemStyle={itemStyle}
              readMore={readMore}
              handleCategoryChange={handleCategoryChange}
            />
          ))}
        </Slider>
      </div>
    ) : null
  }
}

DhsvPostHighlightSlider.propTypes = {
  isMD: PropTypes.bool,
  readMore: PropTypes.string,
  title: PropTypes.string,
  headline: PropTypes.string,
  handleCategoryChange: PropTypes.func,
  data: PropTypes.array,
}

export default DhsvPostHighlightSlider
